import { types } from '../actions/SessionActions';
import reducerUtils from './ReducerUtils';

export const defaultState = {
    appReady: false,
    childSessionInfo: undefined,
    childResumed: undefined,
    context: undefined,
    criticalErrorOccurred: false,
    debugParams: {},
    invigilatorAuthorized: false,
    isLoggedIn: undefined,
    language: undefined,
    mode: undefined,
    navigationLock: { isLocked: false, reason: null, owner: null },
    printParams: undefined,
    layoutParams: undefined,
    questionSetIdentifier: undefined,
    requestParameterIds: undefined,
    resumed: undefined,
    resumedTestAfterPassword: undefined,
    sessionInfo: undefined,
    viewMedia: undefined,
    catTriggerInProgress: false,
};

function updateSignedWebSocketUrl(state, signedWebSocketUrl) {
    const sessionInfo = state.sessionInfo ? { ...state.sessionInfo } : {};
    sessionInfo.signedWebSocketUrl = signedWebSocketUrl;
    return Object.assign({}, state, { sessionInfo });
}

export default function (state = defaultState, action) {
    switch (action.type) {
    case types.SESSION_REPLACE_ALL:
        return { ...defaultState, ...action.parameters };

    case types.SESSION_SET_PARAMETERS:
        return reducerUtils.applyProps(state, action.parameters);

    case types.SESSION_TOGGLE_NAVIGATION_LOCK:
        return Object.assign({}, state, {
            navigationLock: action.navigationLock,
        });

    case types.SESSION_TOGGLE_INVIGILATOR_AUTHORIZED:
        return Object.assign({}, state, {
            invigilatorAuthorized: action.invigilatorAuthorized,
        });

    case types.SESSION_SET_SIGNED_WEB_SOCKET_URL:
        return updateSignedWebSocketUrl(state, action.signedWebSocketUrl);

    default:
        return state;
    }
}
